<template>
  <div class="timeline">
    <div class="timeline-background absolute-box" />
    <div ref="buffered" class="buffered absolute-box" />
    <div ref="watched" class="watched absolute-box" />
    <div ref="input" @click="setTimelineValue" class="input absolute-box"/>
    <div ref="thumb" class="timeline-thumb absolute-box"><eye-icon/></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import KeyProcessor from '@/js/KeyProcessor'

export default {
  name: 'timeline',
  props: {
    isVisible: Boolean
  },
  watch: {
    isVisible: 'updateVisibility',
    currentTime: 'updateTimelinePositions',
    buffered: 'updateBufferedTimeline',
    duration: 'videoChanged'
  },
  computed: {
    ...mapState({
      currentTime: state => state.video.timeline.currentTime,
      buffered: state => state.video.timeline.buffered,
      duration: state => state.video.timeline.duration
    })
  },
  methods: {
    ...mapMutations({ setCurrentTime: 'video/SET_CURRENT_TIME' }),
    updateVisibility() {
      this.updateTimelinePositions()
      this.updateBufferedTimeline()
    },
    setTimelineValue(event) {
      document.activeElement.blur()
      this.$emit('click')

      const amountWatched = event.x / event.target.clientWidth
      this.setCurrentTime(this.duration * amountWatched)
    },
    returnTimeline() {
      this.setCurrentTime(Math.max(this.currentTime - 5, 0))
    },
    forwardTimeline() {
      this.setCurrentTime(Math.min(this.currentTime + 5, this.duration))
    },
    updateTimelinePositions() {
      if (!this.isVisible) return

      const amountWatched = this.currentTime / this.duration
      this.$refs.watched.style.transform = `scaleX(${amountWatched})`

      const currentWidth = this.$refs.watched.clientWidth * amountWatched
      this.$refs.thumb.style.left = `${currentWidth - 8}px`
    },
    updateBufferedTimeline() {
      if (!this.isVisible) return

      const buffersContainer = this.$refs.buffered
      this.buffered.forEach((buffer, i) => {
        const startPosition = buffer.start / this.duration
        const amountWatched = (buffer.end / this.duration) - startPosition

        let currentChild = buffersContainer.children[i]
        if (!currentChild) {
          currentChild = document.createElement('div')
          currentChild.className = 'asdasdasd'
          buffersContainer.appendChild(currentChild)
        }

        currentChild.style.width = `${amountWatched * buffersContainer.clientWidth}px`
        currentChild.style.left = `${startPosition * 100}%`
      })
    },
    videoChanged() {
      if (this.duration === 0) {
        this.$refs.watched.style.transform = 'scaleX(0)'
        this.$refs.thumb.style.left = '-8px'
      }
    }
  },
  mounted() {
    this.keyProcessor = new KeyProcessor({
      37: this.returnTimeline,
      39: this.forwardTimeline
    })
  },
  destroyed() {
    this.keyProcessor.removeListener()
  }
}
</script>

<style lang="scss" scoped>
.timeline {
  position: relative;
  height: 8px;

  .absolute-box {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
  }

  & > .input.absolute-box {
    pointer-events: all;
    cursor: pointer;
    background: transparent;
    appearance: none;
    margin: 0;
    width: 100%;
    height: 100%;
  }

  & > .timeline-background {
    transform-origin: left;
    width: 100%;
    height: 100%;
    background-color: $timeline-background-color;
  }

  & > .watched {
    transform-origin: left;
    transform: scaleX(0);
    width: 100%;
    height: 100%;
    background-color: $timeline-watched-color;
  }

  & > .buffered {
    position: relative;
    transform-origin: left;
    width: 100%;
    height: 100%;
  }

  & > .timeline-thumb {
    left: -8px;
    top: -9px;
    width: 18px;
    height: auto;
  }
}
</style>

<style lang="scss">
.timeline-thumb > svg {
  & > .eyelashes {
    transform-origin: bottom;
    transition-delay: 0s;
  }

  & > * {
    transition: transform 0.2s ease-out;
    transform-origin: center;
    transform-box: fill-box;

    @media screen and (min-width: 1025px) {
      transform: scale(0, 0);
    }
  }

  & > path:not(.eyelashes) {
    transform-box: view-box;
  }
}

.timeline:hover > .timeline-thumb > svg > * {
  &.eyelashes {
    transition-delay: 0.15s;
  }

  transform: scale(1, 1);
}

.buffered > div {
  position: absolute;
  top: 0;
  left: 0;
  background-color: $timeline-buffered-color;
  width: 0;
  height: 100%;
}
</style>
